import type { ComparisonConfig } from './ComparisonPage';

const OPERA_ZH: ComparisonConfig = {
  slug: 'hotelstack-vs-opera',
  competitorName: 'Oracle OPERA',
  heroTitle: 'HotelStack.io 对比 Oracle OPERA',
  heroSubtitle: 'Oracle OPERA是传统行业标准——几十年前构建，至今仍承载着企业级的复杂性和定价。HotelStack.io提供现代云原生替代方案，拥有更多模块、更简单定价和零基础设施开销。',
  overviewComparison: [
    { label: '技术架构', hotelstack: '云原生SaaS', competitor: '传统本地/云端' },
    { label: '定价', hotelstack: '起价$49/月', competitor: '$500+/月 + 许可证' },
    { label: '实施', hotelstack: '免费——48小时入驻', competitor: '3-6个月实施' },
    { label: '模块总数', hotelstack: '36个内置', competitor: '20+（需单独许可证）' },
    { label: '餐饮/POS', hotelstack: '内置', competitor: '需单独OPERA POS许可证' },
    { label: '目标客群', hotelstack: '中小到企业级', competitor: '仅企业级' },
  ],
  featureTable: [
    {
      category: '核心PMS',
      features: [
        { name: '预订管理', hotelstack: true, competitor: true },
        { name: '可视化房态板', hotelstack: true, competitor: true },
        { name: '夜审向导', hotelstack: true, competitor: true },
        { name: '宾客账单管理', hotelstack: true, competitor: true },
        { name: '团队预订', hotelstack: true, competitor: true },
        { name: '在线入住门户', hotelstack: true, competitor: '附加模块' },
      ],
    },
    {
      category: '云端与可访问性',
      features: [
        { name: '真正的云原生', hotelstack: true, competitor: '混合' },
        { name: '零服务器维护', hotelstack: true, competitor: false },
        { name: '实时多设备同步', hotelstack: true, competitor: '有限' },
        { name: '现代响应式UI', hotelstack: true, competitor: false },
        { name: '自动更新', hotelstack: true, competitor: false },
        { name: '无需IT人员', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '收益管理',
      features: [
        { name: '动态定价规则', hotelstack: true, competitor: true },
        { name: '假设场景收益模拟器', hotelstack: true, competitor: false },
        { name: '竞争对手价格监控', hotelstack: true, competitor: '通过Oracle BI' },
        { name: '需求预测', hotelstack: true, competitor: true },
        { name: 'RevPAR分析', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '餐饮与运营',
      features: [
        { name: 'POS终端', hotelstack: true, competitor: '需单独许可证' },
        { name: '客房送餐模块', hotelstack: true, competitor: '需单独许可证' },
        { name: '厨房显示系统', hotelstack: true, competitor: false },
        { name: '员工排班', hotelstack: true, competitor: false },
        { name: '维修工单', hotelstack: true, competitor: '通过集成' },
      ],
    },
    {
      category: '成本与入驻',
      features: [
        { name: '免费入驻', hotelstack: true, competitor: false },
        { name: '免费数据迁移', hotelstack: true, competitor: false },
        { name: '无服务器成本', hotelstack: true, competitor: false },
        { name: '无许可证费用', hotelstack: true, competitor: false },
        { name: '区域货币定价', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '弹性与离线',
      features: [
        { name: '支持离线的PWA', hotelstack: true, competitor: false },
        { name: '离线操作队列', hotelstack: true, competitor: false },
        { name: '重新连接时后台同步', hotelstack: true, competitor: false },
        { name: '冲突感知对账', hotelstack: true, competitor: false },
        { name: '可安装的前台系统', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '企业与团队销售',
      features: [
        { name: '企业协议价管理', hotelstack: true, competitor: '附加模块' },
        { name: '团队预订与房间名单', hotelstack: true, competitor: '附加模块' },
        { name: '应收账龄与业绩报表', hotelstack: true, competitor: '附加模块' },
        { name: '餐厅预订', hotelstack: true, competitor: 'Micros附加模块' },
      ],
    },
    {
      category: '员工与人力资源',
      features: [
        { name: '员工名录与排班', hotelstack: true, competitor: '通过集成' },
        { name: '薪资处理', hotelstack: true, competitor: false },
        { name: '休假与考勤', hotelstack: true, competitor: false },
        { name: '绩效分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$500+',
    hotelstackNote: '包含全部36个模块。无许可证费。无服务器成本。免费入驻和迁移。支持EUR、GBP、AED、INR、THB区域定价。',
    competitorNote: '企业许可证每物业$500+/月。POS、S&C和OCRM需单独许可证。实施费用$50,000起。经典版需本地服务器。',
  },
  advantages: [
    '总拥有成本降低90%以上——无许可证费、服务器成本或实施费用',
    '48小时上线，对比OPERA 3-6个月的实施周期',
    '现代云原生UI，任何设备可访问——无需桌面客户端',
    '一个订阅包含全部36个模块，对比OPERA需单独模块许可证',
    '零IT基础设施——无需服务器、补丁或Oracle DBA',
    '内置餐饮和POS无额外费用，对比OPERA需单独POS许可证',
    '6种货币区域定价，酒店以本地货币支付',
    '从OPERA免费数据迁移，专属支持团队',
  ],
  verdict: {
    title: '我们的评价',
    summary: 'Oracle OPERA数十年来一直是行业标准，对于拥有现有Oracle基础设施的大型企业连锁酒店仍是可靠选择。然而，对于绝大多数酒店而言，HotelStack.io提供更多模块、更好的UX和显著更低的成本，无需OPERA所要求的多月实施周期、服务器开销和复杂许可证。',
    bestFor: [
      '希望消除昂贵Oracle许可证和基础设施成本的酒店',
      '厌倦OPERA缓慢实施和升级周期的物业',
      '需要现代云原生UI而不依赖桌面客户端的酒店',
      '被OPERA企业级定价排除在外的中小型物业',
      '希望所有模块包含在内无需单独许可证费的物业',
    ],
  },
  faqItems: [
    { question: '能否从Oracle OPERA迁移到HotelStack.io？', answer: '可以。我们的迁移团队专门处理OPERA到HotelStack的过渡。我们导入宾客档案、预订历史、房价代码、房间配置和团队预订。迁移免费，通常在48-72小时内完成，零停机时间。' },
    { question: 'HotelStack.io是否支持与OPERA相同的集成？', answer: 'HotelStack.io连接100多个OTA、通过Amadeus和Sabre的GDS以及主要支付网关。我们的集成市场覆盖相同的生态系统。我们还提供开放API用于自定义集成。' },
    { question: 'HotelStack.io与OPERA Cloud相比如何？', answer: 'OPERA Cloud是Oracle对其传统产品的现代化。HotelStack.io从第一天起就以现代技术栈构建为云原生。我们提供更多模块（36对OPERA Cloud基础版）、更简单定价、更快入驻，且不依赖Oracle基础设施。' },
    { question: 'HotelStack.io适合目前使用OPERA的大型连锁酒店吗？', answer: '适合。我们的连锁和企业套餐支持多物业管理，含集中分析、房价分销和品牌标准——与让大型连锁酒店留在OPERA的功能相同，但成本仅为其一小部分。' },
  ],
};

const RMS_CLOUD_ZH: ComparisonConfig = {
  slug: 'hotelstack-vs-rms-cloud',
  competitorName: 'RMS Cloud',
  heroTitle: 'HotelStack.io 对比 RMS Cloud',
  heroSubtitle: 'RMS Cloud服务于亚太酒店市场，具备扎实的PMS基础。HotelStack.io在此基础上扩展为36个模块、全球多币种定价、内置餐饮/POS和高级收益管理——价格更低。',
  overviewComparison: [
    { label: '模块总数', hotelstack: '36个集成模块', competitor: '12+模块' },
    { label: '定价', hotelstack: '起价$49/月', competitor: '起价$80+/月' },
    { label: '全球覆盖', hotelstack: '40多个国家', competitor: '主要覆盖亚太' },
    { label: '餐饮/POS', hotelstack: '内置', competitor: '不可用' },
    { label: '收益管理', hotelstack: '高级（内置）', competitor: '基础' },
    { label: '预订引擎', hotelstack: 'BookMyRoom.io（免费）', competitor: '基础小工具' },
  ],
  featureTable: [
    {
      category: '核心PMS',
      features: [
        { name: '云端PMS', hotelstack: true, competitor: true },
        { name: '可视化房态板', hotelstack: true, competitor: true },
        { name: '预订管理', hotelstack: true, competitor: true },
        { name: '夜审向导', hotelstack: true, competitor: true },
        { name: '团队预订', hotelstack: true, competitor: true },
        { name: '在线入住门户', hotelstack: true, competitor: '有限' },
      ],
    },
    {
      category: '收益与分销',
      features: [
        { name: '渠道管理（100+ OTA）', hotelstack: true, competitor: 'OTA数量有限' },
        { name: '动态定价规则', hotelstack: true, competitor: false },
        { name: '竞争对手价格监控', hotelstack: true, competitor: false },
        { name: '假设场景收益模拟器', hotelstack: true, competitor: false },
        { name: '需求预测', hotelstack: true, competitor: '基础' },
        { name: 'RevPAR分析', hotelstack: true, competitor: '基础' },
      ],
    },
    {
      category: '宾客管理',
      features: [
        { name: '360度宾客档案', hotelstack: true, competitor: '基础' },
        { name: '忠诚度计划管理', hotelstack: true, competitor: false },
        { name: '宾客沟通自动化', hotelstack: true, competitor: '有限' },
        { name: '宾客消费分析', hotelstack: true, competitor: false },
        { name: '证件上传与验证', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '餐饮与运营',
      features: [
        { name: 'POS终端', hotelstack: true, competitor: false },
        { name: '客房送餐模块', hotelstack: true, competitor: false },
        { name: '厨房显示系统', hotelstack: true, competitor: false },
        { name: '客房清洁管理', hotelstack: true, competitor: true },
        { name: '维修工单', hotelstack: true, competitor: false },
        { name: '员工排班与薪资', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '多物业与合规',
      features: [
        { name: '连锁酒店仪表盘', hotelstack: true, competitor: true },
        { name: '跨物业分析', hotelstack: true, competitor: '有限' },
        { name: '多币种账单', hotelstack: true, competitor: '以AUD为主' },
        { name: '区域税务合规', hotelstack: true, competitor: '仅亚太' },
        { name: 'GDPR数据保护', hotelstack: true, competitor: '有限' },
      ],
    },
    {
      category: '弹性与离线',
      features: [
        { name: '支持离线的PWA', hotelstack: true, competitor: false },
        { name: '离线操作队列', hotelstack: true, competitor: false },
        { name: '重新连接时后台同步', hotelstack: true, competitor: false },
        { name: '冲突感知对账', hotelstack: true, competitor: false },
        { name: '可安装的前台系统', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '企业与团队销售',
      features: [
        { name: '企业协议价管理', hotelstack: true, competitor: false },
        { name: '团队预订与房间名单', hotelstack: true, competitor: '有限' },
        { name: '应收账龄与业绩报表', hotelstack: true, competitor: false },
        { name: '餐厅预订', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '员工与人力资源',
      features: [
        { name: '员工名录与排班', hotelstack: true, competitor: false },
        { name: '薪资处理', hotelstack: true, competitor: false },
        { name: '休假与考勤', hotelstack: true, competitor: false },
        { name: '绩效分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$80+',
    hotelstackNote: '包含全部36个模块。支持EUR、GBP、AED、INR、THB区域定价。免费入驻和数据迁移。',
    competitorNote: '以AUD计价，起价$80+/月。渠道管理和高级功能需额外收费。主要支持亚太地区。',
  },
  advantages: [
    '模块数量近三倍（36对12+），更低价格包含所有功能',
    '覆盖40多个国家，对比RMS Cloud主要聚焦亚太市场',
    '完整的餐饮模块，含POS终端、客房送餐和厨房管理',
    '高级收益管理，含动态定价、需求预测和模拟器',
    '更强的渠道连接能力，100多个OTA和通过Amadeus及Sabre的GDS',
    '员工管理，含排班、薪资、考勤和绩效追踪',
    '6种货币多币种账单，对比主要基于AUD的定价',
    '免费入驻和数据迁移，全天候专属支持',
  ],
  verdict: {
    title: '我们的评价',
    summary: 'RMS Cloud是具备扎实住宿管理基础的亚太物业的可靠PMS。HotelStack.io提供更全面的解决方案，拥有36个模块、全球覆盖、高级收益管理和完整的餐饮/POS功能——价格更低。对于希望超越基础PMS进入全面酒店运营管理的物业，HotelStack.io是更强的选择。',
    bestFor: [
      '希望获得超越基础PMS的完整一体式平台的酒店',
      '需要内置餐饮、POS和厨房管理的物业',
      '拓展亚太以外市场需要全球合规和分销的酒店',
      '需要高级收益管理和动态定价的物业',
      '需要全球物业集中分析的多物业连锁酒店',
    ],
  },
  faqItems: [
    { question: '能否从RMS Cloud迁移到HotelStack.io？', answer: '可以。我们的迁移团队负责从RMS Cloud完整迁移数据，包括宾客档案、预订历史、房价配置和房间设置。迁移免费，通常在48小时内完成，零停机时间。' },
    { question: 'HotelStack.io对澳大利亚和亚太酒店效果好吗？', answer: '当然好。HotelStack.io支持包括AUD在内的多币种账单、亚太市场区域税务合规以及亚太地区OTA连接。许多亚太物业因额外模块和全球覆盖而从RMS Cloud转向我们。' },
    { question: 'HotelStack.io与RMS Cloud的定价如何比较？', answer: 'HotelStack.io起价$49/月，包含全部36个模块和6种货币区域定价。RMS Cloud起价约$80+/月AUD，模块较少，渠道管理和高级功能需额外收费。' },
    { question: 'HotelStack.io是否像RMS Cloud一样支持度假公园和营地？', answer: 'HotelStack.io专为所有住宿类型设计，包括酒店、度假村、旅社、精品酒店和服务式公寓。虽然RMS Cloud有度假公园的专项功能，但HotelStack.io灵活的物业配置支持多样化的住宿模式。' },
  ],
};

export const COMPARISON_ZH_P2: Record<string, ComparisonConfig> = {
  'hotelstack-vs-opera': OPERA_ZH,
  'hotelstack-vs-rms-cloud': RMS_CLOUD_ZH,
};
